/**
 * ANT MOTOS — Login por e-mail (header + página /account/login)
 * Redireciona com ?email= e ?login_hint= para tentar pré-preencher no destino.
 */
(function () {
  'use strict';

  function buildLoginUrl(base, email) {
    var trimmed = (email || '').trim();
    if (!trimmed) return null;

    try {
      var url = new URL(base, window.location.origin);
      url.searchParams.set('email', trimmed);
      url.searchParams.set('login_hint', trimmed);
      return url.toString();
    } catch (err) {
      var sep = base.indexOf('?') >= 0 ? '&' : '?';
      return base + sep + 'email=' + encodeURIComponent(trimmed) + '&login_hint=' + encodeURIComponent(trimmed);
    }
  }

  function prefillEmailOnPage() {
    var params = new URLSearchParams(window.location.search);
    var email = params.get('email') || params.get('login_hint');
    if (!email) return;

    var selectors = [
      'input[name="customer[email]"]',
      'input[type="email"][name="email"]',
      '#customer\\[email\\]',
      '#header-login-email',
      'input[type="email"]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var input = document.querySelector(selectors[i]);
      if (input && !input.closest('[data-ant-email-login]')) {
        input.value = decodeURIComponent(email.replace(/\+/g, ' '));
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        break;
      }
    }
  }

  function bindEmailLoginForms() {
    document.querySelectorAll('[data-ant-email-login]').forEach(function (form) {
      if (form.dataset.antEmailLoginBound === '1') return;
      form.dataset.antEmailLoginBound = '1';

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input[type="email"]');
        var email = input ? input.value : '';
        var base = form.getAttribute('data-login-url') || '/account/login';
        var url = buildLoginUrl(base, email);

        if (!url) {
          if (input) input.focus();
          return;
        }

        try {
          localStorage.setItem('ant_login_email', email.trim());
        } catch (err) { /* ignore */ }

        window.location.href = url;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindEmailLoginForms();
      prefillEmailOnPage();
    });
  } else {
    bindEmailLoginForms();
    prefillEmailOnPage();
  }

  document.addEventListener('shopify:section:load', function () {
    bindEmailLoginForms();
    prefillEmailOnPage();
  });
})();
